<template>
  <section
    class="component-ec8273f4"
    resmed-component-name="promo_quote_30/70_link"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row align-items-center">
          <div class="col-md-3 offset-md-1">
            <figure class="mb-4 mb-md-0">
              <img class="img-fluid" v-bind:src="acf.image" alt="" />
            </figure>
          </div>
          <div class="col-md-6 offset-md-1">
            <blockquote>
              <h4 v-html="acf.quote"></h4>
              <cite v-html="acf.cite"></cite>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ec8273f4", // promo_quote_30/70_link
  props: ["acf"],
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ec8273f4 {
  // -->
}

.component {
  padding: 3rem 0;

  @media (min-width: 992px) {
    padding: 5rem 0;
  }

  blockquote {
    // border-left: 1px solid #ddd;

    h4 {
      // hanging-punctuation: first;
      text-indent: -0.425em;
    }
  }

  cite {
    font-style: normal;
    @extend %body-small;
  }

  figure {
    max-width: 200px;

    @media (min-width: 992px) {
      max-width: none;
    }

    img {
      border-radius: 50%;
    }
  }
}
</style>